import React, { Component } from 'react';
import {
	Select,
} from '@material-ui/core';
import { hasFeature } from '../index';

class SelectWithPermissions extends Component {
	render() {
		const props = { ...this.props };
		if (hasFeature(this.props) === false) {
			props.disabled = true;
		}

		return (<Select {...props} />);
	}
}

export default SelectWithPermissions;



// WEBPACK FOOTER //
// ./src/components/Features/components/Select.js